<template>
  <BaseLightBox :boxNumber="1" :mode="mode">
    <template #title>
      <v-skeleton-loader
        v-if="loading"
        type="text"
        width="200"
      ></v-skeleton-loader>
      <template v-else>
        <span v-if="docNumber !== 'cart'"
          >{{ docTypeName
          }}<span class="doc-number-title">{{ " " + docNumber }}</span></span
        >
        <span v-else-if="docNumber == 'cart'">{{
          $t("SingleOrder.NewOrder")
        }}</span>
      </template>
    </template>
    <template #top-left-action-btn>
      <slot name="top-left-action-btn"></slot>
    </template>
    <div class="orderinfo">
      <div class="boxes-container d-flex justify-space-between ga-4">
        <div class="box-item">
          <InnerBox :title="$t('SingelDoc.shipAddress')" :iscart="iscart">
            <template #content>
              <v-skeleton-loader
                v-if="loading"
                height="20px"
                class="skeleton-input"
              ></v-skeleton-loader>
              <span v-else>
                {{ theDoc?.Customer?.address ?? "" }}
              </span>
            </template>
          </InnerBox>
        </div>
        <div class="contact-box-container box-item">
          <InnerBox
            :title="$t('SingelDoc.contact')"
            id="contact"
            :iscart="iscart"
          >
            <template #content>
              <v-skeleton-loader
                v-if="loading"
                height="20px"
                class="skeleton-text"
              ></v-skeleton-loader>
              <span v-else>
                {{
                  `${theDoc?.User?.name ?? ""}${
                    theDoc?.User?.phoneNumber && !isMobile
                      ? ", " + theDoc?.User?.phoneNumber
                      : ""
                  }`
                }}
              </span>
            </template>
          </InnerBox>
        </div>
        <div class="box-item" v-if="!iscart">
          <InnerBox :title="$t('SingelDoc.status')">
            <template #content>
              <v-skeleton-loader
                v-if="loading"
                height="20px"
                class="skeleton-text"
              ></v-skeleton-loader>
              <span v-else>
                {{ theDoc?.Status?.statusname ?? "" }}
              </span>
            </template>
          </InnerBox>
        </div>
      </div>
    </div>
  </BaseLightBox>
</template>

<script>
import { mapGetters } from "vuex/dist/vuex.cjs.js";
import BaseLightBox from "../UI/BaseLightBox.vue";
import InnerBox from "../UI/InnerBox.vue";

export default {
  components: {
    BaseLightBox,
    InnerBox,
  },
  emits: [
    "set-has-change",
    "edit-doc-reference",
    "edit-doc-shppingCode",
    "selectChoice",
  ],
  data() {
    return {
      selectedShippingCode: "",
      docAddressInput: "לא קיימת כתובת",
      loading: true,
    };
  },
  props: {
    docTypeName: {
      type: String,
    },
    docNumber: {
      type: String,
    },
    mode: {
      type: String,
      required: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    theDoc: {
      type: Object,
      required: true,
    },
    iscart: {
      type: Boolean,
      default: false,
    },
    shipTypes: {
      type: Array,
    },
  },
  watch: {
    selectedShippingCode(val) {
      this.$emit("edit-doc-shppingCode", val);
    },
    theDoc: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          this.initializeData();
        }
      },
    },
  },
  mounted() {
    this.initializeData();
  },
  methods: {
    initializeData() {
      if (this.editable) {
        var stcode = this.$store.getters["AuthModule/getCustomerData"]?.stcode;
        if (stcode) {
          this.selectedShippingCode = this.getShipTypesByStcode(stcode)?.stdes;
          this.$emit("selectChoice", this.getShipTypesByStcode(stcode));
        } else {
          this.selectedShippingCode = this.shipTypes?.[0]?.stdes;
          this.$emit("selectChoice", this.shipTypes?.[0]);
        }
      } else {
        this.selectedShippingCode = null;
        if (this.theDoc?.stcode) {
          this.selectedShippingCode = this.getShipTypesByStcode(
            this.theDoc.stcode
          )?.stdes;
        }
      }
      const address = this.theDoc?.User?.Customer?.address;
      const city = this.theDoc?.User?.Customer?.city;
      if (address && city) {
        this.docAddressInput = address + ", " + city;
      }
    },
    selectChoice(val) {
      this.$emit("selectChoice", val);
    },
    setPhoneDefaultValue() {
      return this.iscart
        ? this.$store.getters["AuthModule/getUserName"]
        : this.theDoc?.User
        ? this.theDoc.User.name
        : "";
    },
    yalashinuim() {
      this.$emit("set-has-change", true);
    },
    getPhoneByName(name) {
      for (let user of this.getCustData.Users) {
        if (name == user.name) return user.phone;
      }
      return;
    },
  },
  computed: {
    boxItemWidthPercentage() {
      if (this.mode === "cart") return "100%";
      return "35%";
    },
    ...mapGetters({
      isMobile: "isMobile",
    }),
    isEditableClass() {
      return this.editable ? "editable" : "";
    },
    ...mapGetters({
      getCustData: "AuthModule/getCustomerData",
      getShipTypesByStcode: "shipTypes/getShipTypesByStcode",
    }),
  },
};
</script>

<style scoped lang="scss">
#contact {
  background-color: $primaryBackgroundColor;
  padding: 20px;
}

@media (max-width: 1440px) {
  .orderinfo input {
    margin: 0;
  }
  .boxes-container {
    flex-wrap: wrap-reverse;
  }
}

.box-item {
  flex: 1 1 v-bind(boxItemWidthPercentage);
}

.doc-number-title {
  font-weight: 300;
  color: $DeepGray;
}

.skeleton-input,
.skeleton-text {
  width: 100%;
}

select {
  display: block;
  border-radius: 10px;
  font-size: $mediumTextSize;
  font-weight: 400;
  line-height: 21.33px;
  text-align: right;
  color: $orderLineColor;
  opacity: 1;
}

.orderinfo input,
.orderinfo span {
  width: 100% !important;
  border-radius: 10px;
  font-size: $mediumTextSize !important;
  font-weight: 400;
  line-height: 21.33px;
  text-align: right;
  height: fit-content !important;
  color: $orderLineColor;
}

.orderinfo input.editable {
  border: 1px solid $borderColor;
  padding: 15px 10px 15px 10px;
  gap: 5px;
  border-radius: 10px;
  border: 1px 0px 0px 0px;
  opacity: 0px;
  background: white;
}
</style>
